import { baseApi } from "./baseApi";

export const qrApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({

    // ✅ GET /api/qr-code — retourne SVG directement
    getQrCode: builder.query({
      query: () => ({
        url: "/qr-code",
        responseHandler: (response) => response.text(),
      }),
      providesTags: ["QrTokens"],
    }),

    // ✅ POST /api/qr-tokens
    generateQrToken: builder.mutation({
      query: (body) => ({
        url: "/qr-tokens",
        method: "POST",
        body,
      }),
      invalidatesTags: ["QrTokens"],
    }),

    // ✅ POST /api/pointages/scanQr
    scanQr: builder.mutation({
      query: (body) => ({
        url: "/pointages/scanQr",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Presences"],
    }),
  }),
});

export const {
  useGetQrCodeQuery,
  useGenerateQrTokenMutation,
  useScanQrMutation,
} = qrApi;